/** @jsx jsx */
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import circleSvg from "./circleIcon.svg"

export const circleIcon = vwoService.isThemeRebrandedEnabled()
  ? circleSvg
  : {
      path: <circle cx="10" cy="10" r="10" fill="currentColor" />,
    }
